import { Row } from "@dgs/core";
import { Fragment } from "react";
import { Trans } from "react-i18next";
import { ShopSummaryTaxResource } from "../../../shared/types";

interface Props {
	taxes: ShopSummaryTaxResource[];
}

export function TaxDisclaimers({ taxes }: Props) {
	return (
		<Row>
			{taxes.map((tax, index) => (
				<Fragment key={tax.percent}>
					<span>
						<Trans
							i18nKey="<sup>{{taxDisclaimer}}</sup> includes {{percent}}% VAT"
							values={{ taxDisclaimer: index + 1, percent: tax.percent }}
							components={{ sup: <sup /> }}
						/>
					</span>
					{index !== taxes.length - 1 && <span>|</span>}
				</Fragment>
			))}
		</Row>
	);
}
